import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/joy';
import { contactLocalTime, timeZoneLabel } from './contactTimeZoneUtils';

export function ContactTimeZone({ zone, source, now }: { zone?: string; source?: string; now?: number }) {
  const [clock, setClock] = useState(() => Date.now());
  useEffect(() => {
    if (now !== undefined || !zone) return;
    const timer = window.setInterval(() => setClock(Date.now()), 60_000);
    return () => window.clearInterval(timer);
  }, [now, zone]);
  if (!zone) return <Typography level="body-xs">Time zone unknown</Typography>;
  return (
    <Box component="span" sx={{ display: 'block' }} title={source === 'browser' ? 'Detected from their browser; may differ from their business time zone.' : 'Staff selected'}>
      <Typography component="span" level="body-xs" sx={{ display: 'block' }}>{timeZoneLabel(zone)}</Typography>
      <Typography component="span" level="body-xs" sx={{ display: 'block', color: 'text.secondary' }}>
        {contactLocalTime(zone, now ?? clock)} local time{source === 'browser' ? ' · Browser detected' : ''}
      </Typography>
    </Box>
  );
}
